import { ReactNode } from 'react';

type Tone = 'success' | 'danger' | 'primary';

const TONES: Record<Tone, { bg: string; border: string; color: string }> = {
  success: { bg: 'rgba(34,197,94,0.15)', border: 'rgba(34,197,94,0.4)', color: '#22C55E' },
  danger: { bg: 'rgba(239,68,68,0.15)', border: 'rgba(239,68,68,0.3)', color: '#EF4444' },
  primary: { bg: 'rgba(251,58,174,0.15)', border: 'rgba(251,58,174,0.4)', color: '#FB3AAE' },
};

/** Centered icon + title + message block used for "check your email" / error states. */
export function AuthStatus({
  icon,
  tone = 'success',
  title,
  children,
  action,
}: {
  icon: ReactNode;
  tone?: Tone;
  title: string;
  children?: ReactNode;
  action?: ReactNode;
}) {
  const t = TONES[tone];
  return (
    <div className="flex flex-col items-center text-center">
      <div
        className="flex items-center justify-center mb-6 rounded-full"
        style={{ width: 72, height: 72, backgroundColor: t.bg, border: `2px solid ${t.border}`, color: t.color }}
      >
        {icon}
      </div>
      <h1 className="text-[24px] font-extrabold tracking-tight mb-3">{title}</h1>
      {children && (
        <div className="text-white/55 text-[15px] leading-relaxed max-w-[320px]">{children}</div>
      )}
      {action && <div className="mt-8">{action}</div>}
    </div>
  );
}
